export class CurrencyHelper {


    static getCurrencySymbol = (currencyId: string): string => {
        let currencySymbol: string;
        switch (parseInt(currencyId)) {
            case 32:
                currencySymbol = "UYU";//se muestra $
                break;
            case 840:
                currencySymbol = "USD";
                break;
            case 858:
            default:
                currencySymbol = "UYU";
                break;
        }

        return currencySymbol;
    }

    static getCurrencyPrefix = (currencyId: string): string => {
        switch (parseInt(currencyId)) {
            case 840:
                return "US$";
            case 32:
            case 858:
            default:
                return "$";
        }
    }

    static isAndroidDevice = (): boolean => {
        if (typeof navigator === "undefined" || !navigator.userAgent) {
            return false;
        }

        return /Android/i.test(navigator.userAgent);
    }

    static formatCurrencyAmount = (currencyId: string, amount: number, locale: string = "es-UY"): string => {
        const numericAmount = Number(amount);
        const safeAmount = Number.isFinite(numericAmount) ? numericAmount : 0;
        const currencyCode = CurrencyHelper.getCurrencySymbol(currencyId);
        const formattedAmount = Intl.NumberFormat(locale, {
            style: "currency",
            currency: currencyCode
        }).format(safeAmount);

        if (CurrencyHelper.isAndroidDevice() && parseInt(currencyId) === 32) {
            return formattedAmount.replace(/UYU/g, "$");
        }

        return formattedAmount;
    }
}